import React, { useMemo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import A from '../A';
import styles from './styles';
var useStyles = createUseStyles(styles);
var NavPath = function NavPath(props) {
  var classesProp = props.classes,
    className = props.className,
    links = props.links,
    variant = props.variant;
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  var $thisWrapper = useRef();
  var $thisMenu = useRef();

  // scroll to the current element in navpath
  useEffect(function () {
    if (typeof window !== 'undefined' && $thisMenu.current.scrollWidth > $thisMenu.current.offsetWidth) {
      var currentElementOffset = $thisMenu.current.querySelector(".".concat(classes.linkCurrent)).offsetLeft;
      $thisWrapper.current.scrollLeft = currentElementOffset;
    }
  }, [classes.linkCurrent]);
  return /*#__PURE__*/React.createElement("nav", {
    className: cx(classes.container, className, variant === 'small' ? classes.containerSmall : classes.containerBig)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper,
    ref: $thisWrapper
  }, /*#__PURE__*/React.createElement("ul", {
    className: classes.links,
    ref: $thisMenu
  }, links.map(function (link, index) {
    var _link$linkProps, _link$linkProps$route, _link$linkProps2, _link$linkProps2$rout;
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(A, {
      className: cx(classes.link, link.isCurrent === true && classes.linkCurrent, link.isInactive === true && classes.linkInactive),
      href: link.linkProps.href,
      route: (_link$linkProps = link.linkProps) == null ? void 0 : (_link$linkProps$route = _link$linkProps.route) == null ? void 0 : _link$linkProps$route.name,
      routeParams: (_link$linkProps2 = link.linkProps) == null ? void 0 : (_link$linkProps2$rout = _link$linkProps2.route) == null ? void 0 : _link$linkProps2$rout.params,
      onClick: link.isCurrent === true || link.isInactive === true ? function (e) {
        e.preventDefault();
      } : null
    }, /*#__PURE__*/React.createElement("span", null, link.linkProps.label)));
  }))));
};
NavPath.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.shape({
    isCurrent: PropTypes.bool,
    isActive: PropTypes.bool,
    linkProps: PropTypes.shape(A.propTypes)
  })),
  variant: PropTypes.oneOf(['big', 'small'])
};
NavPath.defaultProps = {
  className: null,
  classes: {},
  links: null,
  variant: 'big'
};
export default withMemo()(NavPath);